const classes = {
    btn: 'twc__tab-btn',
    pane: 'twc__tab-pane',
    active: 'twc__tab-active',
};

class Tabs {
    constructor( el ) {
        if ( !el ) {
            throw new Error( 'cannot create tabs without root element' );
        }

        this.root = el;
        this.panes = this.root.getElementsByClassName( classes.pane );
        this.btns = this.root.getElementsByClassName( classes.btn );

        this.activeBtn = null;

        for ( let i = 0; i < this.btns.length; i++ ) {
            this.btns[ i ].addEventListener( 'click', this.onTabClick.bind( this ) );

            if ( this.btns[ i ].classList.contains( classes.active ) ) {
                this.activeBtn = this.btns[ i ];
            }
        }
    }

    onTabClick( event ) {
        var targetSelector = event.target.dataset.target;

        if ( !targetSelector ) {
            return;
        }

        var targetPane = document.querySelector( targetSelector );

        if ( !targetPane ) {
            return;
        }

        var activePane = document.querySelector( '.' +  classes.pane + '.' +  classes.active );

        if ( activePane ) {
            activePane.classList.remove( classes.active );
        }

        targetPane.classList.add( classes.active );

        this.activeBtn.classList.remove( classes.active );
        this.activeBtn.disabled = false;

        this.activeBtn = event.target;
        this.activeBtn.classList.add( classes.active );
        this.activeBtn.disabled = true;

        this.root.dispatchEvent( new CustomEvent( 'twc:tabs-show', {
            detail: {
                activeBtn: this.activeBtn,
                activePane: targetPane,
            },
            bubbles: true,
        } ) );
    }
}

export default Tabs;
